import { render, staticRenderFns } from "./SnsFixed.vue?vue&type=template&id=103f91e8&scoped=true"
import script from "./SnsFixed.vue?vue&type=script&lang=js"
export * from "./SnsFixed.vue?vue&type=script&lang=js"
import style0 from "./SnsFixed.vue?vue&type=style&index=0&id=103f91e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103f91e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('103f91e8')) {
      api.createRecord('103f91e8', component.options)
    } else {
      api.reload('103f91e8', component.options)
    }
    module.hot.accept("./SnsFixed.vue?vue&type=template&id=103f91e8&scoped=true", function () {
      api.rerender('103f91e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SnsFixed.vue"
export default component.exports